"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deepExploreArray = deepExploreArray;
exports.visitArrayItems = void 0;
function deepExploreArray(obj, depth) {
  var currentDepth = 0;
  var currentObj = obj;
  while (depth > currentDepth) {
    if (!Array.isArray(currentObj)) {
      throw new TypeError('Error while explore array on depth #' + currentDepth);
    }
    currentObj = currentObj[0];
    currentDepth++;
  }
  return currentObj;
}
/**
 * Visit each item in array recursively
 */
var visitArrayItems = function (arr, visitor) {
  arr.forEach(function (obj) {
    if (Array.isArray(obj)) {
      visitArrayItems(obj, visitor);
    } else {
      visitor(obj);
    }
  });
};
exports.visitArrayItems = visitArrayItems;
//# sourceMappingURL=data:application/json;charset=utf8;base64,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



//////////////////
// WEBPACK FOOTER
// ./node_modules/@translate-tools/core/translators/GoogleTranslator/utils.js
// module id = Y0tr
// module chunks = 0